import { saveStoreState } from '../data/persist/store-state';
import { isLocalLink } from './isLocalLink';
import { openLink } from './openLinks';

window.addEventListener('message', function (receivedMessage) {
    try {
        switch (receivedMessage?.data?.type) {
            case 'RELOAD':
                saveStoreState();
                window.location.reload();
                break;
            case 'MEET_NAVIGATION':
                if (isLocalLink(receivedMessage.data.url)) {
                    app.store.dispatch(app.actions.ui.sidePanel.reset());
                    openLink(receivedMessage.data.url);
                } else {
                    app.store.dispatch(app.actions.ui.sidePanel.iframeNavigation(receivedMessage.data.url));
                }
                break;
            case 'MEET_CLOSE':
                app.store.dispatch(app.actions.ui.sidePanel.reset());
                break;
            default:
            // console.log('Unknown message received: ', receivedMessage);
        }
    } catch (err) {}
});
